import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
  HttpParams,
} from "@angular/common/http";
import { Subject, interval, Subscription, EMPTY } from "rxjs";
import { switchMap, filter, take, catchError } from "rxjs/operators";
import data_settingMAO from "../../assets/json/MaoProject.json";
import { Notification } from "../Admin/notification-center/Models/notification.model";
import { NotificationRequest } from "../Admin/notification-center/Models/notification-request.model";


const httpOptions = {
  headers: new HttpHeaders({
    "Content-Type": "application/json",
    withCredentials: "true",
    Authorization: "true",
  }),
};
let headers: any = {};

const hostGeneral = data_settingMAO.RestApi;

@Injectable({
  providedIn: "root",
})
export class NotificationService {

  // 2026-03-02 JBDCR: Subject to trigger a notification refresh from any component after a report completes.
  refreshNotifications$ = new Subject<void>();

  myItemSession: any;
  httpOptions2: any = {};
  headers: HttpHeaders = new HttpHeaders({
    "Content-Type": "application/json",
    //Authorization: localStorage.getItem("accessToken")
  });

  constructor(private http: HttpClient) {
    this.SetHeadersToken();
    // 2026-03-02 JBDCR: When tab regains focus, trigger a notification refresh as a backup in case polling was throttled by the browser.
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        this.refreshNotifications$.next();
      }
    });
  }

  SetHeadersToken() {
    this.myItemSession = localStorage.getItem("SessionMAO");
    if (this.myItemSession == null) {
      let key = "SessionMAO";
      let valueSession = { validate: "false", name: "" };
      localStorage.setItem(key, JSON.stringify(valueSession));
      this.myItemSession = localStorage.getItem("SessionMAO");
    }
    this.myItemSession = JSON.parse(this.myItemSession);
    this.httpOptions2 = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      }),
    };
    headers = {
      "Content-Type": "application/json"
    };
  }

  SetHeadersTokenbackup() {
    this.myItemSession = localStorage.getItem("SessionMAO");
    this.myItemSession = JSON.parse(this.myItemSession);
    if (this.myItemSession != null) {
      this.httpOptions2 = {
        headers: new HttpHeaders({
          "Content-Type": "application/json"
        }),
      };
      headers = {
        "Content-Type": "application/json"
      };
    } else {
      this.httpOptions2 = {
        headers: new HttpHeaders({
          "Content-Type": "application/json"
        }),
      };
      headers = {
        "Content-Type": "application/json"
      };
    }
  }

  /**
   * 2021/10/21 CJR~UsrStory#354
   * Description: Method to get alert types from data model.
   * @returns [] strings
   */
  getAlertTypes() {
    return this.http
      .get(`${hostGeneral}/api/Notification/GetAlertTypes`, this.httpOptions2)
      .toPromise();
  }

  /**
  * 2021/10/21 CJR~UsrStory#354
  * Description: Method to request notification report by select filters 
  */
  getNotificationReport(notificationRpt: NotificationRequest) {
    return this.http
      .post<NotificationRequest>(
        `${hostGeneral}/api/Notification/GetNotificationReport`,
        notificationRpt,
        { headers }
      )
      .toPromise();
  }

  /**
  * 2021-10-21 CJR~UsrStory#354 
  * Description: Function to get notifications by id 
  * @param notificationId 
  */
  getNotificationById(notificationId) {
    let parameters = new HttpParams();
    const body = { notificationId };
    parameters = parameters.append("notificationId", notificationId);

    return this.http
      .post(`${hostGeneral}/api/Notification/GetNotificationById`, body, {
        headers: headers,
        params: parameters,
      })
      .toPromise();
  }

  /**
   * 2021-10-05 CJR~UsrStory#354
   * Description:  Function to request user notification to display
   * @param userID 
   * @param rolID 
   */
  getNotificationToDisplay(userID, rolID) {
    let parameters = new HttpParams();

    parameters = parameters.append("userId", userID);
    parameters = parameters.append("rolId", rolID);

    return this.http
      .get(`${hostGeneral}/api/Notification/GetNotificationToDisplay`, {
        headers: headers,
        params: parameters,
      })
      .toPromise();

  }

  /**
   * 2025-06-10 JBDCR~UsrStory#1480 
   * Description: Function to update the display date of a notification
   * @param alertID
   * @param userID 
   */
  updateNotificationDisplayDate(alertID, userID) {
    return this.http.post(`${hostGeneral}/api/Notification/UpdateNotificationDisplayDate?userID=${userID}&alertID=${alertID}`, {}, { headers: headers }).toPromise();
  }

  /**
   * 2025-06-10 JBDCR~UsrStory#1480 
   * Description: Function to update the display date of a notification
   * @param alertID
   * @param userID 
   */
  markNotificationAsAcknowledged(alertID, userID) {
    return this.http.post(`${hostGeneral}/api/Notification/MarkNotificationAsAcknowledged?userID=${userID}&alertID=${alertID}`, {}, { headers: headers }).toPromise();
  }

  /**
   * 2025-06-10 JBDCR~UsrStory#1480 
   * Description: Function to update the display date of a notification
   * @param alertID
   * @param userID 
   */
  markNotificationsAsDismissed(alertIDs: number[], userID: number) {
    // Sends the data in the body (as JSON)
    return this.http.post(
      `${hostGeneral}/api/Notification/MarkNotificationsAsDismissed`,
      { alertIDs, userID },
      { headers: headers }
    ).toPromise();
  }


  /**
   * 2021-10-28 CJR~UsrStory#354 
   * Description: Function to get last five notifications history by user and role id
   * @param userID 
   * @param rolID 
   */
  getNotificationsHistoryByRolId(userID, rolID) {
    let parameters = new HttpParams();

    parameters = parameters.append("userID", userID);
    parameters = parameters.append("rolID", rolID);

    return this.http.get(`${hostGeneral}/api/Notification/GetNotificationsHistoryByRolId`, { headers: headers, params: parameters }).toPromise();

  }

  /**
   * 2021-11-01 CJR~UsrStory#354
   * Description: Method to get users who already read a notification 
   * @param notificationId 
   */
  getUsersWhoReadNotification(notificationId) {
    let parameters = new HttpParams();

    parameters = parameters.append("notificationId", notificationId);

    return this.http.get(`${hostGeneral}/api/Notification/GetUsersWhoReadNotification`, { headers: headers, params: parameters }).toPromise();
  }

  /**
  * 2021/10/21 CJR~UsrStory#354
  * Description: Method to create a new notification 
  */
  setNewAlert(notification: Notification) {
    return this.http
      .post<Notification>(
        `${hostGeneral}/api/Notification/SetNewNotification`,
        notification,
        { headers }
      )
      .toPromise();
  }

  /**
  * 2021-10-21 CJR~UsrStory#354 
  * Description: Method to edit a notification
  */
  updateNotification(editNotification: Notification) {
    return this.http
      .post<Notification>(
        `${hostGeneral}/api/Notification/UpdateNotification`,
        editNotification,
        { headers }
      )
      .toPromise();
  }

  /**
  * 2021-10-28 CJR~UsrStory#354 
  * Description: Function to update notification(s) as read by user
  */
  updateNotificatiosAsRead(userID) {
    let parameters = new HttpParams();
    const body = { userID }
    parameters = parameters.append("userID", userID);
    return this.http.post(`${hostGeneral}/api/Notification/UpdateNotificationsAsRead`,
      body,
      {
        headers: headers,
        params: parameters
      }
    ).toPromise();
  }

  /**
  * 2021-10-21 CJR~UsrStory#354
  * Description: Method to set logically removed status to the notification
  * @param notificationId
  */
  removeNotification(notificationId) {
    let parameters = new HttpParams();
    const body = { notificationId };
    parameters = parameters.append("notificationId", notificationId);

    return this.http
      .post(`${hostGeneral}/api/Notification/RemoveNotification`, body, {
        headers: headers,
        params: parameters,
      })
      .toPromise();
  }

  // 2026-03-02 JBDCR: Gets the current status of a report request by ID.
  getReportRequestStatus(reportRequestID: number) {
    let parameters = new HttpParams();
    parameters = parameters.append("ReportRequestID", reportRequestID.toString());
    return this.http.get(`${hostGeneral}/api/ReportUser/GetReportRequestStatus`, { headers: headers, params: parameters });
  }

  // 2026-03-02 JBDCR: Polls every 2s for a report request status. Uses RxJS interval+switchMap to stay inside Angular's zone so the notification refresh triggers change detection correctly. Stops on status 3 (completed) or 4 (failed).
  private activePollingSubscriptions = new Set<Subscription>();

  startReportPolling(reportRequestID: number): void {
    const sub = interval(2000).pipe(
      switchMap(() => {
        return this.getReportRequestStatus(reportRequestID);
      }),
      filter((resp: any) => resp && resp.code === 200 && resp.Value && (resp.Value.Status === 3 || resp.Value.Status === 4)),
      take(1),
      catchError(() => EMPTY)
    ).subscribe((resp: any) => {
      this.refreshNotifications$.next();
      this.activePollingSubscriptions.delete(sub);
    });
    this.activePollingSubscriptions.add(sub);
  }

}
